<template>
  <v-container>
  <v-row dense no-gutters>
    <v-col cols="12" class="align-start">
      <ws-g-o-s-t-selector :f-t_-i-d="'-5'" :set-global-filter="false" :as-filter="true" v-model="selectedGOST"></ws-g-o-s-t-selector>
    </v-col>
    <v-col cols="8">
      <ref-grades-local-table :value="selectedGrade" @input="onGradeChange" :g-o-s-t="selectedGOST"/>
    </v-col>
    <v-col cols="4">
      <ref-fuel-grade-card :grade="selectedGrade.length ? selectedGrade[0] : {}" :mode="'viewer'"/>
    </v-col>
    <v-col cols="12">
      <grade-properties-card :grade="selectedGrade.length ? selectedGrade[0] : {}" :active-tab="'tabProperties'"/>
    </v-col>
  </v-row>
    <ref-add-grade2-g-o-s-t-dialog v-model="dlgShowAdd" :grade="selectedGrade.length ? selectedGrade[0] : {}" @gradeAdded="onGradeChange" @gradeUpdate="onGradeChange"/>
    <sys-confirm-dialog :value="dlgShowConfirm" :message="'Подтвердите удаление'" :no-call-back="cancelConfirmDialog" :ok-call-back="doDeleteGrade"/>
  </v-container>
</template>

<script>
import { UI_ADD_ACTION, UI_SET_ACTIONS, UI_SNACKBAR } from '@/store/actions/ui'
import WsGOSTSelector from '@/components/modules/projects/ui/wsGOSTSelector'
import RefGradesLocalTable from '@/components/modules/references/refGradesLocalTable'
import RefFuelGradeCard from '@/components/modules/references/cards/refFuelGradeCard'
import RefAddGrade2GOSTDialog from '@/components/modules/references/dialogs/refAddGrade2GOSTDialog'
import SysConfirmDialog from '@/components/common/dialogs/confirmDialog'
import axios from 'axios'
import GradePropertiesCard from '@/components/modules/references/cards/gradePropertiesCard'
export default {
  name: 'refFuelGradesList',
  components: { GradePropertiesCard, SysConfirmDialog, RefAddGrade2GOSTDialog, RefFuelGradeCard, RefGradesLocalTable, WsGOSTSelector },
  props: ['accessKey'],
  data () {
    return {
      addAction: { text: 'Добавить элемент', actionType: 'Справочник Топлива по ГОСТ', action: 'addGrade', method: this.showAddDialog, icon: 'mdi-beaker-plus' },
      updAction: { text: 'Редактировать элемент', actionType: 'Справочник Топлива по ГОСТ', action: 'updGrade', method: this.showEditDialog, icon: 'mdi-beaker-check' },
      delAction: { text: 'Удалить элемент', actionType: 'Справочник Топлива по ГОСТ', action: 'delGrade', method: this.showDelDialog, icon: 'mdi-beaker-minus' },
      selectedGOST: null,
      selectedGrade: [],
      dlgShowAdd: false,
      dlgShowConfirm: false
    }
  },
  watch: {
    accessKey (val) {
      console.log('Called for accessKey ', val)
      if (val !== 'forms/refFuelGradesList') {
        this.$store.dispatch(UI_SET_ACTIONS, { actionType: 'Справочник Топлива по ГОСТ' })
      } else {
        this.setActions()
      }
    }
  },
  methods: {
    setActions () {
      console.log('Setting actions')
      this.$store.dispatch(UI_SET_ACTIONS, { actionType: 'Справочник Топлива по ГОСТ' })
      this.$store.dispatch(UI_ADD_ACTION, this.addAction)
      if (this.selectedGrade.length) {
        this.$store.dispatch(UI_ADD_ACTION, this.updAction)
        this.$store.dispatch(UI_ADD_ACTION, this.delAction)
      }
    },
    showAddDialog () {
      console.log('showAddDialog in refFuelGradesList')
      this.selectedGrade.splice(0, 1)
      this.dlgShowAdd = true
    },
    showEditDialog () {
      console.log('selectedGrade in refFuelGradesList is ', this.selectedGrade[0])
      this.dlgShowAdd = true
    },
    showDelDialog () {
      console.log('Calling for confirm dialog')
      this.dlgShowConfirm = true
    },
    cancelConfirmDialog () {
      this.dlgShowConfirm = false
    },
    doDeleteGrade () {
      console.log('Closing confirm dialog')
      this.dlgShowConfirm = false
      const self = this
      const processorPath = '/api/org/references/delGrade2GOST.php'
      const payload = { ...this.selectedGrade[0] }
      axios({
        url: processorPath,
        method: 'POST',
        data: payload
      })
        .then(resp => {
          if (resp.data.error === 'ok') {
            self.selectedGrade.splice(0, 1, { action: 'delete', GRADE_ID: self.selectedGrade[0].GRADE_ID })
          } else {
            self.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка: \n ${resp.data.error_text}` })
          }
        })
        .catch((err) => {
          self.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка: \n ${err}` })
        })
    },
    onGradeChange (item) {
      console.log('Grade changed', item)
      this.selectedGrade.splice(0, 1, ...item)
      console.log('Now grade is', this.selectedGrade)
      this.setActions()
    }
  },

  mounted () {
    console.log('refFuelGradesList reference module mounted')
    this.setActions()
  }
}
</script>
